import { useMutation } from '@tanstack/react-query';
import { Endpoint } from '@/constants';
import { postData } from '@/utils/postData';

export const useCheckEmail = (
  handleServerValidation: (errorObj: Record<string, string>) => void,
) => {
  const { mutate } = useMutation({
    mutationFn: postData(Endpoint.EmailExists),
    onSuccess: data => {
      if (data.isSuccess) {
        handleServerValidation({});
      } else {
        handleServerValidation({ email: data.messages[0] });
      }
    },
  });

  return { checkEmail: mutate };
};
